import { render, staticRenderFns } from "./round-disabled.mpx?vue&type=template&id=64ee0dfd&isComponent&outputPath=components%2Fround-disabledd37508c0%2Findex"
import script from "./round-disabled.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fround-disabledd37508c0%2Findex"
export * from "./round-disabled.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fround-disabledd37508c0%2Findex"
import style0 from "./round-disabled.mpx?vue&type=style&index=0&id=64ee0dfd&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_d37508c0%22%7D&isComponent&outputPath=components%2Fround-disabledd37508c0%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports